import apiClient from "./apiClient";

export const fetchDashboard = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (val !== null && val !== undefined && val !== "") query.append(key, val);
  });
  const qs = query.toString();
  const url = `/master/commons/student-category/dashboard${qs ? `?${qs}` : ""}`;
  const res = await apiClient.get(url);
  return res.data;
};

export const fetchCompetencyStats = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (val !== null && val !== undefined && val !== "") query.append(key, val);
  });
  const qs = query.toString();
  const url = `/master/commons/student-category/competency-stats${qs ? `?${qs}` : ""}`;
  const res = await apiClient.get(url);
  return res.data;
};

export const fetchFIComplianceReport = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (val !== null && val !== undefined && val !== "") query.append(key, val);
  });
  const qs = query.toString();
  const url = `/field-execution/po-visit/compliance-report${qs ? `?${qs}` : ""}`;
  const res = await apiClient.get(url);
  return res.data;
};

export const exportAssessmentData = async ({ cycle_ids = [], ...rest } = {}) => {
  const query = new URLSearchParams();
  (cycle_ids || []).forEach((id) => query.append("cycle_ids", id));
  Object.entries(rest).forEach(([key, val]) => {
    if (val !== null && val !== undefined && val !== "") query.append(key, val);
  });
  const qs = query.toString();
  const url = `/field-execution/po-visit/assessment-data-export${qs ? `?${qs}` : ""}`;
  const res = await apiClient.get(url, { responseType: "blob" });
  return res.data;
};
